import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import AboutView from '../views/AboutView.vue'
import ContactView from '../views/ContactView.vue'
import PortfolioView from '../views/PortfolioView.vue'
import ShopView from '../views/ShopView.vue'
import VideosView from '../views/VideosView.vue'

const routes = [
  {
    path: '/',
    alias: '/home',
    name: 'Home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'About',
    component: AboutView
  },
  {
    path: '/contact',
    name: 'Contact',
    component: ContactView
  },
  {
    path: '/portfolio',
    name: 'Portfolio',
    component: PortfolioView
  },
  {
    path: '/shop',
    name: 'Shop',
    component: ShopView
  },
  {
    path: '/videos',
    name: 'Videos',
    component: VideosView
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
